/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Aicost_2_KInputs */

const en_mk_aicost_2_k = /** @type {(inputs: Mk_Aicost_2_KInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One chat message to an agent`)
};

const id_mk_aicost_2_k = /** @type {(inputs: Mk_Aicost_2_KInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu pesan chat ke agen`)
};

/**
* | output |
* | --- |
* | "One chat message to an agent" |
*
* @param {Mk_Aicost_2_KInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_aicost_2_k = /** @type {((inputs?: Mk_Aicost_2_KInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Aicost_2_KInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_aicost_2_k(inputs)
	return en_mk_aicost_2_k(inputs)
});